import {
  isDefined,
  type APIError,
  type PermissionEntityId,
  type PermissionListInput,
  type PermissionListSuccess,
} from '@terros/common'
import { useQueries, type UseQueryResult } from '@tanstack/react-query'
import { useTantalimQuery } from '../query'
import { permissionsKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { useServerRequest } from '../api'

export const MAX_PERMISSION_COMPARE_ENTITIES = 5

export function usePermissions(entityId: PermissionEntityId | undefined): GetHookResponse<PermissionListSuccess> {
  return useTantalimQuery<PermissionListInput, PermissionListSuccess, PermissionListSuccess>({
    url: '/permission/list',
    queryKey: permissionsKey(entityId),
    input: { entityId },
    convertResponse: (data) => data,
    options: {
      enabled: isDefined(entityId),
    },
  })
}

export function usePermissionComparisons(
  entityIds: (PermissionEntityId | undefined)[]
): UseQueryResult<PermissionListSuccess, APIError>[] {
  const serverRequest = useServerRequest<PermissionListInput, PermissionListSuccess>('/permission/list')

  return useQueries({
    queries: entityIds.slice(0, MAX_PERMISSION_COMPARE_ENTITIES).map((entityId) => ({
      queryKey: permissionsKey(entityId),
      queryFn: () => serverRequest({ entityId }),
      enabled: isDefined(entityId),
      retry: false,
    })),
  })
}
